import { render, staticRenderFns } from "./gradeDorm.vue?vue&type=template&id=ca1e859a&scoped=true"
import script from "./gradeDorm.vue?vue&type=script&lang=js"
export * from "./gradeDorm.vue?vue&type=script&lang=js"
import style0 from "./gradeDorm.vue?vue&type=style&index=0&id=ca1e859a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1e859a",
  null
  
)

export default component.exports